import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Zap } from "lucide-react";
import AdImage from "@/components/AdImage";
import api from "@/lib/api";

// Sponsor ticker shown on the public live scoreboard (zone="ticker").
export default function SponsorTicker() {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    api.get("/config/ads", { params: { zone: "ticker" } })
      .then(({ data }) => setAds(data || []))
      .catch(() => setAds([]));
  }, []);

  if (ads.length === 0) return null;

  return (
    <section
      data-testid="sponsor-ticker"
      className="py-4 border-y grain"
      style={{ borderColor: "var(--border)", background: "var(--surface)" }}
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {ads.map((ad) => {
          const inner = (
            <div className="flex items-center gap-3 mx-8" data-testid={`ticker-ad-${ad.ad_id}`}>
              {ad.image_url && (
                <AdImage src={ad.image_url} alt={ad.title} className="h-9 w-16 object-cover rounded-md" />
              )}
              <Zap className="w-4 h-4 text-primary-c" />
              <span className="font-display font-bold text-sm tracking-tight">{ad.title}</span>
              <span className="text-[10px] tracking-[0.3em] text-primary-c">· SPONSOR</span>
            </div>
          );
          return ad.link ? (
            <a key={ad.ad_id} href={ad.link} target="_blank" rel="noreferrer">{inner}</a>
          ) : (
            <div key={ad.ad_id}>{inner}</div>
          );
        })}
      </Marquee>
    </section>
  );
}
